export default function preloadImage(src) {
    const image = new window.Image();
    image.src = src;
}



// WEBPACK FOOTER //
// ./~/@99designs/utils/network/preloadImage.js